module.exports = __webpack_public_path__ + "img/logo-svyaznoy.7286e449.jpg";